// // src/components/auth/RegisterStep2.jsx

// import React, { useState, useEffect } from "react";
// import { FiCheckCircle } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";

// const RegisterStep2 = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     dob: "",
//     religion: "",
//     motherTongue: "",
//     email: "",
//     phone:"" ,// Ensure email is retained
//     gender:"" ,// Ensure email is retained
//   });

//   const religions = [
//     "Hindu", "Muslim", "Christian", "Sikh", "Jain",
//     "Buddhist", "Parsi", "Jewish", "No Religion",
//     "Spiritual - not religious", "Other",
//   ];

//   const motherTongues = [
//     "Hindi", "Bengali", "Telugu", "Marathi", "Tamil", "Urdu",
//     "Gujarati", "Kannada", "Odia", "Punjabi", "Malayalam",
//     "Assamese", "Maithili", "Other",
//   ];
//   const gender = [
//    "Male" , "Female" ,"other"
//   ];

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem("registrationData"));
//     if (savedData) {
//       setFormData((prev) => ({
//         ...prev,
//         dob: savedData.dob || "",
//         religion: savedData.religion || "",
//         motherTongue: savedData.motherTongue || "",
//         email: savedData.email || "",
//         phone: savedData.phone || "",
//         gender: savedData.gender || "",
//       }));
//     }
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/register-step3");
//   };

//   const handleBack = () => {
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/");
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
//       <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">

//         {/* Left Section */}
//         <div className="md:w-1/2 bg-green-50 flex flex-col justify-center items-center p-8">
//           <FiCheckCircle className="text-green-600 text-7xl mb-6" />
//           <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
//             Trusted by thousands of Indians across the world.
//           </p>
//         </div>

//         {/* Right Section (Form) */}
//         <div className="md:w-1/2 w-full p-8">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
//             Please provide us with your basic details
//           </h2>
//           <p className="text-sm text-gray-500 mb-6">
//             Your date of birth helps us find the perfect match
//           </p>

//           <form onSubmit={handleSubmit} className="space-y-5">
//             <div>
//               <label className="block text-gray-700 mb-1">Date Of Birth</label>
//               <input
//                 type="date"
//                 name="dob"
//                 value={formData.dob}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-gray-700 mb-1">Religion</label>
//               <select
//                 name="religion"
//                 value={formData.religion}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               >
//                 <option value="">Select</option>
//                 {religions.map((religion) => (
//                   <option key={religion} value={religion}>{religion}</option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-gray-700 mb-1">Mother Tongue</label>
//               <select
//                 name="motherTongue"
//                 value={formData.motherTongue}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               >
//                 <option value="">Select</option>
//                 {motherTongues.map((tongue) => (
//                   <option key={tongue} value={tongue}>{tongue}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-1">Gender</label>
//               <select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               >
//                 <option value="">Select</option>
//                 {gender.map((gen) => (
//                   <option key={gen} value={gen}>{gen}</option>
//                 ))}
//               </select>
//             </div>
//  <div>
//               <label className="block text-gray-700 mb-1">Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 placeholder="Email"
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               />
//             </div>
//              <div>
//               <label className="block text-gray-700 mb-1">Phone</label>
//               <input
//                 type="number"
//                 name="phone"
//                 placeholder="Mobile Number"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               />
//             </div>
//             {/* Button Group */}
//             <div className="flex gap-3">
//               <button
//                 type="button"
//                 onClick={handleBack}
//                 className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 Back
//               </button>
//               <button
//                 type="submit"
//                 className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 Continue
//               </button>
//             </div>
//           </form>

//           <p className="text-xs text-center text-gray-400 mt-6">
//             Copyright © 2025. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegisterStep2;

import React, { useState, useEffect } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const RegisterStep2 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    dob: "",
    motherTongue: "",
    phone: "",
    gender: "",
  });

  const [errors, setErrors] = useState({});

  const motherTongues = [
    "Hindi",
    "Marwari",
    "Gujarati",
    "Rajasthani",
    "Mewari",
    "Shekhawati",
    "Malvi",
    "Haryanvi",
    "Punjabi",
    "Marathi",
    "English",
    "Other",
  ];
  const genders = ["Male", "Female", "Other"];

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("registrationData"));
    if (savedData) {
      setFormData((prev) => ({
        ...prev,
        dob: savedData.dob || "",

        motherTongue: savedData.motherTongue || "",

        phone: savedData.phone || "",
        gender: savedData.gender || "",
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.dob) {
      newErrors.dob = "Date of Birth is required.";
    } else {
      const dobDate = new Date(formData.dob);
      const today = new Date();
      const age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      const dayDiff = today.getDate() - dobDate.getDate();

      // Adjust age if birthday hasn't occurred yet this year
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      if (age < 18) {
        newErrors.dob = "You must be at least 18 years old.";
      }
    }

    if (!formData.motherTongue)
      newErrors.motherTongue = "Mother Tongue is required.";
    if (!formData.gender) newErrors.gender = "Gender is required.";
    if (!formData.phone) newErrors.phone = "Phone number is required.";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit phone number.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const existingData =
      JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/register-step4-html");
  };

  const handleBack = () => {
    const existingData =
      JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">
        {/* Left Section */}
        <div className="md:w-1/2 bg-green-50 flex flex-col justify-center items-center p-8">
          <FiCheckCircle className="text-green-600 text-7xl mb-6" />
          <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
            Trusted by thousands of Indians across the world.
          </p>
        </div>

        {/* Right Section (Form) */}
        <div className="md:w-1/2 w-full p-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
            Please provide us with your basic details
          </h2>
          <p className="text-sm text-gray-500 mb-6">
            Your date of birth helps us find the perfect match
          </p>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* DOB */}
            <div>
              <label className="block text-gray-700 mb-1">
                Date Of Birth{" "}
                <span className="text-danger">(Age must be 18+)</span>{" "}
              </label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              />
              {errors.dob && (
                <p className="text-sm text-red-600 mt-1">{errors.dob}</p>
              )}
            </div>

            {/* Religion */}
            {/* <div>
              <label className="block text-gray-700 mb-1">Religion</label>
              <select
                name="religion"
                value={formData.religion}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {religions.map((religion) => (
                  <option key={religion} value={religion}>
                    {religion}
                  </option>
                ))}
              </select>
              {errors.religion && (
                <p className="text-sm text-red-600 mt-1">{errors.religion}</p>
              )}
            </div> */}

            {/* Mother Tongue */}
            <div>
              <label className="block text-gray-700 mb-1">Mother Tongue</label>
              <select
                name="motherTongue"
                value={formData.motherTongue}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {motherTongues.map((tongue) => (
                  <option key={tongue} value={tongue}>
                    {tongue}
                  </option>
                ))}
              </select>
              {errors.motherTongue && (
                <p className="text-sm text-red-600 mt-1">
                  {errors.motherTongue}
                </p>
              )}
            </div>

            {/* Gender */}
            <div>
              <label className="block text-gray-700 mb-1">Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {genders.map((gen) => (
                  <option key={gen} value={gen}>
                    {gen}
                  </option>
                ))}
              </select>
              {errors.gender && (
                <p className="text-sm text-red-600 mt-1">{errors.gender}</p>
              )}
            </div>

            {/* Email */}
            {/* <div>
              <label className="block text-gray-700 mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                placeholder="Email"
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              />
              {errors.email && (
                <p className="text-sm text-red-600 mt-1">{errors.email}</p>
              )}
            </div> */}

            {/* Phone */}
            <div>
              <label className="block text-gray-700 mb-1">Phone</label>
              <input
                type="number"
                name="phone"
                placeholder="Mobile Number"
                value={formData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              />
              {errors.phone && (
                <p className="text-sm text-red-600 mt-1">{errors.phone}</p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                type="button"
                onClick={handleBack}
                className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition duration-200"
              >
                Back
              </button>
              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
              >
                Continue
              </button>
            </div>
          </form>

          <p className="text-xs text-center text-gray-400 mt-6">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterStep2;
